import { type RouteRecordRaw } from 'vue-router';

import { homeRoutes } from './homeRoutes';
import { mcBizRoutes } from './mc';
import { centralRoutes } from './central'; //  Last routes
import { otherRoutes } from './others';
import { policyRoutes } from 'src/router/micros/policyRoutes';
import { payRoutes } from 'src/router/micros/payRoutes';
import { shipRoutes } from 'src/router/micros/shipRoutes';
import { projectRoutes } from 'src/router/micros/projectRoutes';
import { subServiceRoutes } from 'src/router/micros/subServiceRoutes';
import { subAdminRoutes } from 'src/router/micros/subAdminRoutes';
import { subscriberRoutes } from 'src/router/micros/subscriberRoutes';
import { tradeRoutes } from 'src/router/trade';
import { chatRoutes } from 'src/router/micros/chatRoutes';
import { supportRoutes } from 'src/router/micros/supportRoutes';
import { surveyRoutes } from 'src/router/micros/surveyRoutes';
import { infoRoutes } from 'src/router/info'; // Concatenate all mConnect solutions routes

// Concatenate all mConnect solutions routes
const appRoutes: Array<RouteRecordRaw> = [
  ...homeRoutes,
  ...mcBizRoutes,
  ...centralRoutes,
  ...policyRoutes,
  ...payRoutes,
  ...shipRoutes,
  ...supportRoutes,
  ...projectRoutes,
  ...subServiceRoutes,
  ...subAdminRoutes,
  ...subscriberRoutes,
  ...surveyRoutes,
  ...tradeRoutes,
  ...infoRoutes,
  ...chatRoutes,
  ...otherRoutes,
];

export default appRoutes;
